import api from "../api/api";

export const setAuthorizationToken = token => {
    if (token) {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    else
        delete api.defaults.headers.common["Authorization"];
}